import { ImageNone } from '@cian/components';
import * as React from 'react';
import classNames from 'classnames';

import { ISimilarOffer } from '../../../../store/similar';
import { IconsMetro } from '../../icons/IconsMetro';
import { IconsTransport } from '../../icons/IconsTransport';

import * as styles from './SimilarOfferItem.css';

export interface ISimilarOfferItemProps {
  offer: ISimilarOffer;
  position: number;
  className?: string;

  onClick(offer: ISimilarOffer, position: number): void;
}

export class SimilarOfferItem extends React.PureComponent<ISimilarOfferItemProps, {}> {
  public render() {
    const { offer, className } = this.props;

    return (
      <li className={classNames(styles['item'], className)}>
        {/* eslint-disable-next-line react/jsx-no-target-blank */}
        <a href={offer.url} className={styles['link']} target="_blank" onClick={this.handleClick}>
          <div className={styles['image_block']}>{this.renderPreviewImage()}</div>
          <div className={styles['content_block']}>
            <div className={classNames(styles['price'], styles['ellipsis'])}>{offer.formattedPrice}</div>
            <div className={classNames(styles['title'], styles['ellipsis'])}>{offer.title}</div>
            {this.renderAddress()}
            {this.renderUnderground()}
          </div>
        </a>
      </li>
    );
  }

  private renderPreviewImage = () => {
    const { photoUrl, title } = this.props.offer;

    if (!photoUrl) {
      return <ImageNone />;
    }

    return <img src={photoUrl} alt={title} className={styles['image']} />;
  };

  public renderAddress = () => {
    const { address } = this.props.offer;

    if (!address) {
      return null;
    }

    return <div className={classNames(styles['address'], styles['ellipsis'])}>{address}</div>;
  };

  public renderUnderground() {
    const { underground } = this.props.offer;
    const transportLayout = this.renderTransport();

    if (!underground || !underground.name) {
      return null;
    }

    return (
      <div className={styles['underground_block']}>
        <div className={classNames(styles['underground_name'], !transportLayout && styles['full_width'])}>
          <IconsMetro color={underground.color} type={underground.iconType || undefined} />
          <span className={styles['ellipsis']}>{underground.name}</span>
        </div>
        {transportLayout}
      </div>
    );
  }

  public renderTransport() {
    const { underground } = this.props.offer;

    if (!underground || !underground.time || !underground.transportType) {
      return null;
    }

    return (
      <div className={styles['underground_transport']}>
        <IconsTransport type={underground.transportType} />
        <span>{underground.time}</span>
      </div>
    );
  }

  private handleClick = () => {
    this.props.onClick(this.props.offer, this.props.position);
  };
}
